import { FIELD_TYPES } from "constants/template-field-type";
import ThemeConfig from "segments/core-configs/theme-config";
import ScrollableTabsConfig from "segments/desktop/core-components/scrollable-tabs/fields-config.js"

export default {
  type: FIELD_TYPES.NESTED,
  label: "Usecases Gallery",
  fields: {
    ...ThemeConfig,
    usecases: ScrollableTabsConfig,
    defaultSelectedTabLabel: {
      type: FIELD_TYPES.TEXT,
      label: "Default selected tab label"
    }
  }
};
